import VuexPersistence from 'vuex-persist'
import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    reducer: (state) => ({
        cart: state.cart,
        billing_info: state.billing_info,
        shipping_info: state.shipping_info,
        shipping_methods: state.shipping_methods,
    }),
})

let store = {
    state,
    getters,
    actions,
    mutations,
    plugins: [vuexLocal.plugin]
}

export default store
